/**
 * Mapping des erreurs HTTP vers des messages utilisateur
 */

interface ErrorMessage {
  title: string;
  message: string;
}

const errorMessages: Record<number, ErrorMessage> = {
  400: {
    title: 'Requête invalide',
    message:
      'Les données envoyées sont incorrectes. Veuillez vérifier et réessayer.',
  },
  401: {
    title: 'Non authentifié',
    message: 'Votre session a expiré. Veuillez vous reconnecter.',
  },
  403: {
    title: 'Accès refusé',
    message:
      "Vous n'avez pas les autorisations nécessaires pour effectuer cette action.",
  },
  404: {
    title: 'Introuvable',
    message: "La ressource demandée n'a pas été trouvée.",
  },
  409: {
    title: 'Conflit',
    message:
      "Cette opération entre en conflit avec l'état actuel de la ressource.",
  },
  422: {
    title: 'Données invalides',
    message:
      'Les données envoyées ne sont pas valides. Veuillez corriger les erreurs.',
  },
  429: {
    title: 'Trop de requêtes',
    message:
      'Vous avez envoyé trop de requêtes. Veuillez patienter quelques instants.',
  },
  500: {
    title: 'Erreur serveur',
    message: 'Une erreur interne est survenue. Veuillez réessayer plus tard.',
  },
  502: {
    title: 'Service indisponible',
    message: 'Le service est temporairement indisponible. Veuillez réessayer.',
  },
  503: {
    title: 'Service indisponible',
    message: 'Le service est en maintenance. Veuillez réessayer plus tard.',
  },
};

export function getErrorMessage(statusCode: number): ErrorMessage {
  return (
    errorMessages[statusCode] || {
      title: 'Erreur',
      message: 'Une erreur inattendue est survenue.',
    }
  );
}

export function formatApiError(error: any): ErrorMessage {
  // Si c'est une erreur HTTP avec un status code
  if (error?.response?.status) {
    const statusCode = error.response.status;
    const defaultMessage = getErrorMessage(statusCode);

    // Utiliser le message du serveur si disponible
    const serverMessage = error.response.data?.message;
    if (serverMessage) {
      return {
        title: defaultMessage.title,
        message: serverMessage,
      };
    }

    return defaultMessage;
  }

  // Si c'est une erreur réseau
  if (error?.message === 'Network Error' || !navigator.onLine) {
    return {
      title: 'Erreur de connexion',
      message:
        'Impossible de se connecter au serveur. Vérifiez votre connexion internet.',
    };
  }

  // Erreur inconnue
  return {
    title: 'Erreur',
    message: error?.message || 'Une erreur inattendue est survenue.',
  };
}
